<template>
<div class="investmentClues" >
<leftnav class="fl" mkcode="C" itemcode="C-GDXSTJ"></leftnav> 
	<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
		<govheader></govheader>
		<div class="index_left_centerpage">
			<!-- 头部盒子开始 -->
			<div class="whitebox right_topbox">
				<div class="right_boxtitle">
					<span class="fl right_title">{{curWebsite.keyword}}{{curWebsite.type == 2 ?'':'线索'}}</span><cluetips></cluetips> 
					<video-teaching :type="3" seat="top"></video-teaching>
					</div>
					<!-- 筛选项开始 -->
			<div class="opport-screen-list1">
			<div class="spage-searchbox "> 
				<ClueNav tabCode="zdbd"></ClueNav>
				<dl class="opport-screen bdbe" >
					<dt class="fl">产业分类</dt>
					<dd class="fl">
						<!-- <span :class="notionId == 0?'a-screen current':'a-screen'" @click="notionId = 0;">全部</span> -->
					<span  v-for="(list,i) in notionList" :key="'notionList'+i" :class="notionId == list.notionCode?'a-screen current':'a-screen'" @click="selectNotionList(list.notionCode)">{{list.notionText}}</span> 
					</dd>
				</dl>
				<dl class="opport-screen bdbe" >
					<dt class="fl">年份</dt>
					<dd class="fl"> 
					<span v-for="date in dateList" :key="date.year" :class="date.year == dateId?'a-screen current':'a-screen'" @click="selectDateList(data.year)">{{date.year}}</span> 
					</dd>
				</dl>
				<dl class="opport-screen bdbe" >
					<dt class="fl">榜单名称</dt>
					<dd class="fl">
					<span  v-for="(list,i) in rankListName" :key="'rankListName'+i" :class="rankId == list.id?'a-screen current':'a-screen'" @click="selectRankName(list)">{{list.title}}</span>
					</dd>
				</dl>
			</div> 
		</div>
		<!-- 筛选项结束 -->
		</div>
		<!-- 头部盒子结束 -->  
		<!-- 表格内容开始 -->
		<div class="whitebox"> 
				<!-- 重点区域招商 -->
			<div class="enterprise_list_box" style="padding-top: 20px;"> 
			<div class="inveclu-source w95mg">来源：{{rankSource}}</div>
			<!-- 龙头  优质 上市 创新通用表格 -->
			<div class="enterprise_list_box" v-show="enterpristlist.length!=0">
				<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
					<tr>
						<th>排名</th>
						<th>企业名称</th>
						<th>所属产业</th>
						<th>画像标签</th>
						<th>地区</th>
						<!-- <th>企业实力</th> -->
						<th>编辑</th>
					</tr>
					<tr v-for="(list,index) in enterpristlist" :key="index">
						<td>{{(page-1)*pageSize+index+1}}</td>
						<td class="title" @click="routerlinkid('/enterprises',list.stockCode,9,'',curindex)"> 	{{list.title}}</td>
						<td class="conpanytags hastag">
							<span class="span-tag" v-for="item in list.notionlist" :key="item.id" 	@click="tagrouter('/enterpriseTag',0,'notion',item.id,item.name,'all')">{{item.name}}</span>
						</td>
						<td class="conpanytags hastag">
							<span class="span-tag" v-for="item in list.taglist" :key="item.id" @click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name,'all')">{{item.name}}{{item.count}}</span>
						</td>
						<td>{{list.area}}</td>
						<!-- <td>{{list.zs100000}}</td>  -->
						<td class="collectfont1"><span  @click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br/>目标企业</span></td>
					</tr>
				</table>
			</div>
		</div>  
		<!-- 跳页 -->
		<div class="centerpage1 company_pagelist nojump" v-show="totalPage>1">
			<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
				v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
			</zpagenav>
		</div> 
		</div> 
		</div>
	</div>
</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
	  name: 'investmentClues-9',
	  computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
			data(){return{ 
				title:"重点榜单线索", 
				total1:0,
				userdata:{},curWebsite:this.$api.getWebsiteType(), 
				searchtype:9, //线索类型 2以商招商 1本省投资概率 3关键融资 4优质企业   
				enterpristlist:[{title:"标题",taglist:[],notionlist:[],zs100000:74,collectId:0,collectType:13,stockCode:37500,area:'广东'}],  
				notionList:[], dateList:[],dateId:'2022',
				notionId:0,
				rankListName:[ ],
				rankId:'2051',rankSource:'',
				orderField:5, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序  
				page: 1,  //显示的是哪一页
				haspage:true,//是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 100, //记录总数 
				totalPage:1,
				maxPage:10,  //最大页数  
			}},
			created() { 
				this.$nextTick(() => {
						// 禁用右键
						document.oncontextmenu = new Function("event.returnValue=false");
						// 禁用选择
						document.onselectstart = new Function("event.returnValue=false");
				});
			 var _this=this; 
				this.userdata =this.getuserinformain();
				this.getRankList();
		 //初始化获取产业分类、榜单名称后拿到第一个默认值获取企业列表 三个axios
			
			// this.getcompanylist();
			},
			mounted() { 
				document.getElementById('app').style.background = "#f0f3f5";
			},
			methods: {
				//筛选重点榜单名字
				selectRankName(list){
					this.rankId = list.id;
					this.rankSource=list.source;
					this.getcompanylist();
				},
				//获取重点榜单列表
				getRankList(){
					var _this=this;
					this.$axios.get(this.$api.cyl.investclue.rankList(), {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {
						// console.log('省份城市列表',res.data) 
						if (res.data.success) { 
						 console.log(res.data.list)
							_this.notionList=res.data.list;  
							_this.selectNotionList(res.data.list[0].notionCode)
							_this.bus.$emit('loading', false);
						} else {
							
						}
					}).catch(function(error) {
						// 请求失败处理 console.log(error);
					});
				},
				//筛选产业分类时提取时间
				selectNotionList(code){ 
					var exmpleData=[
						{id:102,source:"测试来源1",year:2022,title:'测试榜单1'},{id:103,source:"测试来源2",year:2023,title:'测试榜单2'},{id:104,source:"测试来源3",year:2022,title:'测试榜单3'},
						{id:105,source:"测试来源4",year:2024,title:'测试榜单4'},{id:103,source:"测试来源5",year:2023,title:'测试榜单5'},{id:104,source:"测试来源6",year:2022,title:'测试榜单6'}
						];
					this.notionId=code;
					console.log(code)
					var smdata=[];
				 this.notionList.forEach(list=>{
						if(list.notionCode == code){
							smdata=list.list
						}
					});  
					var data=smdata; 
				//提取相同年份 
					for(var i=0;i<data.length;i++){ 
							data[i].children=[{id:data[i].id,source:data[i].source,title:data[i].title,year:data[i].year}];
							data[i].isrepeat=false;
					}
						for(var i=0;i<data.length;i++){
							var dataname=data[i].year;
							for(var d=i+1;d<data.length;d++){
								var dataname1=data[d].year;
								if(dataname == dataname1 && !data[i].isrepeat){  
									data[i].children.push({id:data[d].id,source:data[d].source,title:data[d].title,year:data[d].year});
									data[d].isrepeat=true;
									// data[i].isrepeat=true;
								}
							}  
						}
						var dds=data.filter(list=>{
							return !list.isrepeat;
						})  
						 
						console.log(dds);
					this.dateList=dds; 
					this.dateId=dds[0].year;
					this.selectDateList(this.dateId);
				}, 
				//筛选时间提取重点榜单列表
				selectDateList(date){
					console.log('筛选时间提取重点榜单列表');
					let data=this.dateList.filter(list=>{
						return list.year == date;
					});
					console.log(data,this.rankListName) 
					this.rankListName=data[0].children;
				 this.rankId=this.rankListName[0].id;
				 this.rankSource=this.rankListName[0].source;
					this.getcompanylist();
				},
				//获取
				getcompanylist(paged) {
					this.bus.$emit('loading', true);
					// console.log('getcompanylist'); 
					this.page=paged?paged:1;
					var _this = this;
					//获取企业列表 
					var ajaxurl = this.$api.cyl.investclue.rankDetail()+'?page='+this.page+'&id='+this.rankId;
					// console.log(ajaxurl);
					this.$axios.get(ajaxurl, {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) { 
						var citycountlist = res.data.cityList;
						if (res.data.success) { 
							console.log(ajaxurl,'5', res.data);
							_this.enterpristlist = res.data.list;
							for (var i = 0; i < res.data.list.length; i++) {
								_this.enterpristlist[i].taglist = _this.taglistfun(_this.enterpristlist[i].tag, _this.enterpristlist[i].tagCode);
								_this.enterpristlist[i].notionlist = _this.taglistfun(_this.enterpristlist[i].notion,_this.enterpristlist[i].notionCode,'notionsort');
							} 
							_this.totalPage = res.data.totalPage;
							_this.pageSize = res.data.pageSize;
							_this.total = res.data.totalRecord;
							// _this.haspage = res.data.list.length == res.data.pageSize;
							_this.bus.$emit('loading', false);
						} else {
							
						}
					}).catch(function(error) {
						// 请求失败处理 console.log(error);
					});
				},
	//时间/分数升降序
			tablesort(field) {
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.getcompanylist();
			},  
			pageHandler: function(page) { 
				this.getcompanylist(page);  
			}, 
			},
	}
</script>

<style scoped> 
 .inveclu-source{
		line-height: 32px;color: #5e83cc;padding-bottom: 15px;
	}
	.inveclu-source a{
		color: #5e83cc;
	}
	.inveclu-source a:hover{
		text-decoration: underline;
	}
</style>
